import { render, staticRenderFns } from "./BsCollapse.vue?vue&type=template&id=556c304e&"
import script from "./BsCollapse.vue?vue&type=script&lang=js&"
export * from "./BsCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports